import React from 'react'
import './weatherConditions.css'

export default function WeatherConditions(props) {
  return (
    <div className="days first">
      <p className="weather-conditions">
        <i className="fas fa-wind"></i>
        <span>{props.wind}</span>
        <strong>m/h</strong>
      </p>
      <p className="weather-conditions">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          enable-background="new 0 0 24 24"
          height="24px"
          viewBox="0 0 24 24"
          width="24px"
          fill="#ec6e4c"
        >
          <rect fill="none" height="24" width="24" />
          <path d="M12,2c-5.33,4.55-8,8.48-8,11.8c0,4.98,3.8,8.2,8,8.2s8-3.22,8-8.2C20,10.48,17.33,6.55,12,2z M12,20c-3.35,0-6-2.57-6-6.2 c0-2.34,1.95-5.44,6-9.14c4.05,3.7,6,6.79,6,9.14C18,17.43,15.35,20,12,20z M7.83,14c0.37,0,0.67,0.26,0.74,0.62 c0.41,2.22,2.28,2.98,3.64,2.87c0.43-0.02,0.79,0.32,0.79,0.75c0,0.4-0.32,0.73-0.72,0.75c-2.13,0.13-4.62-1.09-5.19-4.12 C7.01,14.42,7.37,14,7.83,14z" />
        </svg>
        <span>{props.humidity}</span>
        <strong>%</strong>
      </p>
    </div>
  )
}
